/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

import PropTypes from 'prop-types';
import React from 'react';
import useServer from './use-server';

const ApiContext = React.createContext(); // Not necessary, but recommended.

const useApi = () => React.useContext(ApiContext);

function ApiProvider({ jwtToken, children }) {
  const api = useServer({
    jwtToken,
  });
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

ApiProvider.propTypes = {
  children: PropTypes.node,
  jwtToken: PropTypes.string,
};

export { useApi, ApiProvider, ApiContext };
